"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Table, TextBody } from "@opensea/ui-kit";
import { useItemsWithSkeletons } from "@opensea/ui-kit/hooks";
import { range } from "es-toolkit";
import { useTranslations } from "next-intl";
import { useShallow } from "zustand/react/shallow";
import { DropStatus } from "@/components/collection/drops/constants";
import { withSuspense } from "@/components/suspense/WithSuspense";
import { useCollectionActivity } from "@/hooks/api/activity/use-collection-activity";
import { useDropStore } from "../CollectionDropContext";
import { SalesFeedTableHeader } from "./SalesFeedTableHeader";
import { SalesFeedTableRow } from "./SalesFeedTableRow";
import { SalesFeedTableRowFragment } from "./SalesFeedTableRow.fragment";
const PAGE_SIZE = 20;
export const SalesFeedTable = withSuspense(() => {
  const [status, collectionSlug] = useDropStore(useShallow(state => [state.status, state.collectionSlug]));
  const t = useTranslations("MintModule");
  const filter = {
    activityTypes: ["SALE"]
  };
  const {
    items: paginatedItems,
    pagination,
    itemsLiveAddedAt,
    noResults
  } = useCollectionActivity({
    collectionSlug,
    limit: PAGE_SIZE,
    filter
  });
  const items = useItemsWithSkeletons({
    items: paginatedItems,
    pageSize: PAGE_SIZE,
    isLoadingNext: pagination.isLoadingNext
  });
  const rowContext = {
    itemsLiveAddedAt
  };
  if (noResults) {
    return <div className="relative h-full overflow-hidden">
          <TextBody className="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 z-[1]">
            {status === DropStatus.MINTING_SOON ? t("notStartedYet") : t("noSalesYet")}
          </TextBody>
          <SalesFeedTableSkeleton context={{
        ...rowContext,
        override: {
          Skeleton: {
            className: "animate-none"
          }
        }
      }} />
        </div>;
  }
  return <Table context={rowContext} header={<SalesFeedTableHeader />} itemKey={v => readFragment(SalesFeedTableRowFragment, v)?.id} items={items} renderRow={SalesFeedTableRow} size="md" {...pagination} />;
}, {
  //TODO: skeleton
  fallback: <SalesFeedTableSkeleton />
});
export function SalesFeedTableSkeleton(t0) {
  const $ = _c(4);
  const {
    context
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SalesFeedTableHeader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = range(20).map(_temp2);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== context) {
    t3 = <Table context={context} header={t1} itemKey={_temp} items={t2} renderRow={SalesFeedTableRow} size="md" />;
    $[2] = context;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp2() {}
function _temp(_, index) {
  return index;
}